import React from 'react';
import RiskItem from './RiskItem';

interface RiskData {
  label: string;
  value: number;
  status: 'low' | 'medium' | 'high';
  description?: string;
}

interface RiskListProps {
  risks: RiskData[];
}

const RiskList: React.FC<RiskListProps> = ({ risks }) => {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '20px'
    }}>
      {/* Title */}
      <h2 style={{
        fontFamily: 'BT Beau Sans, sans-serif',
        fontWeight: 800,
        fontSize: '20px',
        lineHeight: '30px',
        textAlign: 'center',
        color: '#007BC2',
        margin: 0,
        width: '100%'
      }}>
        NGUY CƠ TIM MẠCH TRONG 10 NĂM
      </h2>

      {/* Risk Cards Grid */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '15px',
        justifyContent: 'center',
        flexWrap: 'wrap'
      }}>
        {risks.slice(0, 4).map((risk, index) => (
          <RiskItem
            key={index}
            label={risk.label}
            value={risk.value}
            status={risk.status}
            description={risk.description}
          />
        ))}
      </div>
    </div>
  );
};

export default RiskList;
